<ion-app>
  @if (showMainLayout) {
    <ion-split-pane contentId="main-content" when="xs">
      <ion-menu contentId="main-content" type="overlay">
        <ion-header>
          <ion-toolbar>
            <ion-item lines="none">
              <div class="vertical-stack ion-margin-vertical">
                <ion-avatar>
                  <img
                    alt="Silhouette of a person's head"
                    src="https://ionicframework.com/docs/img/demos/avatar.svg"
                  />
                </ion-avatar>
              </div>
            </ion-item>
          </ion-toolbar>
        </ion-header>

        <ion-content class="page-menu-container">
          <ion-list id="page-list">
            @for (page of appPages(); track page.title; let i = $index) {
              <ion-item
                class="menu"
                routerDirection="root"
                [routerLink]="[page.url]"
                lines="none"
                detail="false"
                routerLinkActive="selected"
                [attr.data-testid]="page.testId"
              >
                <div class="vertical-stack ion-margin-vertical">
                  <ion-icon slot="start" size="large" [name]="page.icon"></ion-icon>
                  <ion-label class="page-list-label"> {{ page.title | translate }} </ion-label>
                  @if (page.badge != null) {
                    <ion-badge color="danger">{{ page.badge() }}</ion-badge>
                  }
                </div>
              </ion-item>
            }
          </ion-list>
        </ion-content>
      </ion-menu>
      <div class="ion-page" id="main-content">
        <ion-router-outlet></ion-router-outlet>
      </div>
    </ion-split-pane>
  } @else {
    <ion-router-outlet></ion-router-outlet>
  }
</ion-app>
